module.exports = __webpack_public_path__ + "static/media/arrows-right-down.1d376e97.svg";